export const API_BASE = process.env.OMNIPLATFORM_API;
export const API_PATH = 'documents';
export const API_DOCUMENT_STORAGE_PATH = 'document-storage';
